<div class="card-bien">
  <div class="image" [ngClass]="{ 'maps-parent': parent == 'maps' }">
    <!-- width/height : le CSS de cette carte ne donne qu'un `max-height`, jamais de
         hauteur. Sans ces attributs, la zone image vaut donc 0 px de haut jusqu'à
         l'arrivée de la photo, puis ~251 px : chaque carte pousse tout ce qui la
         suit vers le bas (décalage de mise en page). Les valeurs sont les
         dimensions RÉELLES du fichier (800x600), la taille affichée ne change donc
         pas d'un pixel : elles ne servent qu'à réserver la place à l'avance. -->
    <img (click)="emitEventClicked(bien)" *ngIf="!bien.medium_thumbnails"
      src="{{'../../../../../../assets/resources/web/images/design/defaut-maison.webp'}}"
      width="800" height="600"
      alt="{{bien.niveau.code_text}}" class="image_widget">
    <!-- <img  (click)="bienClicked.emit(bien.id)" *ngIf="!bien.medium_thumbnails" -->
    <!-- src="../../../../../../assets/resources/web/images/design/{{bien.niveau.code_text | lowercase}}.png" -->
    <!-- alt="{{bien.niveau.code_text}}" class="image_widget"> -->
    <!-- role="group" : ngb-carousel pose aria-activedescendant sur son hôte, attribut
         qui n'est autorisé que sur quelques rôles dont "group" (et pas sur un élément
         sans rôle). C'est aussi le rôle recommandé par le pattern carrousel de l'ARIA. -->
    <ngb-carousel [interval]="-1" [showNavigationIndicators]="false" #carousel *ngIf="bien.medium_thumbnails"
      role="group" aria-roledescription="carrousel" aria-label="Photos du bien">
      <!-- width/height : `medium_thumbnails` ne retient QUE les images en 400x300
           (Bien.php, getMediumThumbnailsFront() filtre sur ce nom de fichier), le
           ratio est donc connu d'avance et toujours le même — les attributs
           n'altèrent aucun cadrage. Sans eux, `loading="lazy"` aggrave même la
           situation : les sauts se produisent aussi PENDANT le défilement, et le
           CLS les compte au même titre que ceux du chargement initial. -->
      <ng-template ngbSlide *ngFor="let medium_thumbnail of bien.medium_thumbnails">
        <img (click)="emitEventClicked(bien)"
         loading="lazy"
          width="400" height="300"
          src="{{medium_thumbnail ? medium_thumbnail.path : '../../../../../../assets/resources/web/images/design/s-logo.png' }}"
          alt="{{bien.niveau.code_text}}" class="image_widget">
      </ng-template>
    </ngb-carousel>

    <div class="labels-container">
      <span *ngIf="bien.status.id == 1 && bien.sous_offre" class="btn btn-gold exclusivity-label">Sous offre</span>
      <span *ngIf="bien.sous_promesse" class="btn btn-gold exclusivity-label">Sous&nbsp;promesse</span>
      <span *ngIf="(bien.status.id == 3 || bien.status.id == 6) && !bien.sous_promesse" class="btn btn-gold exclusivity-label">Vendu</span>
      <span *ngIf="bien.status.id == 4 && !bien.sous_promesse" class="btn btn-gold exclusivity-label">Loué</span>
      <span *ngIf="bien.status.id == 1 && bien.vente != 1" class="btn btn-gold exclusivity-label">Location</span>
      <span *ngIf="bien.status.id == 5" class="btn btn-gold exclusivity-label">Retiré</span>
      <span class="btn btn-gold exclusivity-label"
        *ngIf="bien.vente == 1 && bien?.typeMandat && bien?.typeMandat.id === 2 && !bien?.flash">Exclusivité</span>
      <span class="btn btn-gold type-label">{{bien.niveau.code_text}}</span>
    </div>
  </div>
  <!-- Pas de greenTool
  <div *ngIf="!greenTools && bien.status.id != 5 && bien.status.id != 2"
    class="btn-bien d-flex justify-content-between">
    <button type="button" *ngIf="userConnected && !bien.favorite" (click)="onAddFavoris(bien.id)" title="Ajouter aux favoris">
      <i class="bi bi-heart-fill"></i>
    </button>
    <button type="button" *ngIf="userConnected && bien.favorite" title="Retirer des favoris" (click)="onDeleteFavoris(bien.id)">
      <i class="bi bi-heart-fill premium"></i>
    </button>
    <button type="button" title="Offres en cours" class="iconClass border-0 bg-transparent p-0"
      *ngIf="userConnected && userConnected?.type?.id != 7 && bien?.vente">
      <app-modal-offres class="d-flex w-100" [bien]="bien"></app-modal-offres>
      <span class="badge badge-secondary text-bleu-tdm">{{bien.offertCount}}</span>
    </button>

    <button type="button" title="Partager le bien" class="border-0 bg-transparent p-0"> <app-modal-share [colorIcon]="'#00579c'" class="d-flex"
        *ngIf="bien?.status && bien?.status?.id == 1" [bien]="bien"></app-modal-share>
    </button>
    <a *ngIf="bien?.status && bien?.status?.id == 1" title="Imprimer la fiche du bien" [href]="bien.urlFiche"
      target="_blank"><i class="bi bi-printer-fill"></i>
    </a>
  </div>
   end Pas de greenTool -->

  <!-- avec greenTools ?
    <div *ngIf="bien?.vente && greenTools && bien.status.id != 5 && bien.status.id != 2" class="btn-bien d-flex justify-content-between">
  -->

  <!-- Biens En ligne ou Vendu ou Loué -->
  <div *ngIf="bien.status.id != 2 && bien.status.id != 5 && bien.status.id != 6"
    class="btn-bien d-flex justify-content-between">
    <button type="button" *ngIf="userConnected && !bien.favorite && showIconFavorite" (click)="onAddFavoris(bien.id)"
      title="Ajouter aux favoris">
      <i class="bi bi-heart-fill"></i>
    </button>
    <button type="button" *ngIf="userConnected && bien.favorite && showIconFavorite" title="Retirer des favoris"
      (click)="onDeleteFavoris(bien.id)">
      <i class="bi bi-heart-fill premium"></i>
    </button>
    <ng-container *ngIf="showIconVisite && bien.visitCount != 0">
      <app-modal-visites class="d-flex w-100" [bien]="bien" [nbVisites]="bien.visitCount"></app-modal-visites>
    </ng-container>
    <ng-container *ngIf="showIconOffre && bien.offertCount != 0">
      <app-modal-offres class="d-flex w-100" [bien]="bien" [nbOffres]="bien.offertCount"></app-modal-offres>
    </ng-container>
    <ng-container *ngIf="bien.actif_tdm && [1, 3, 4].includes(bien.status.id)">
      <app-modal-share [colorIcon]="'#00579c'" class="d-flex w-100" [bien]="bien" [detailBien]="false"></app-modal-share>
    </ng-container>
    <a *ngIf="showIconPrint && bien?.urlFiche && bien.actif_tdm && [1].includes(bien.status.id)"
       role="button" title="Imprimer la fiche du bien" [href]="bien.urlFiche" target="_blank">
      <i class="bi bi-printer-fill"></i>
    </a>
  </div>
  <!-- Biens en Estimation ou Retiré ou MRB -->
  <div *ngIf="bien.status.id == 2 || bien.status.id == 5 || bien.status.id == 6"
    class="btn-bien d-flex justify-content-between">
    <button type="button" *ngIf="userConnected && bien.favorite && showIconFavorite" title="Retirer des favoris"
      (click)="onDeleteFavoris(bien.id)">
      <i class="bi bi-heart-fill premium"></i>
    </button>
    <button type="button" *ngIf="bien.status.id == 2" ngbTooltip="Bien en estimation" aria-label="Bien en estimation">
      <i style="font-weight: bold;" aria-hidden="true">!</i>
    </button>
    <button type="button" *ngIf="bien.status.id == 5" ngbTooltip="Bien retiré" aria-label="Bien retiré">
      <i style="font-weight: bold;" aria-hidden="true">!</i>
    </button>
    <button type="button" *ngIf="bien.status.id == 6" ngbTooltip="Bien vendu avec un MRA"
      aria-label="Bien vendu avec un MRA">
      <i style="font-weight: bold;" aria-hidden="true">!</i>
    </button>
  </div>
  <!-- todo: Achref : Lien vers bien uniquement si "bien.actif_tdm && [1, 3, 4].includes(bien.status.id) -->
  <!-- todo: Cyrille : Revoir plus tard, le bien doit également avoir une Date de consentement client >= aujourd'hui OU Délég. par partenaire -->
  <a [routerLink]="getBienUrl(bien)" class="infos text-decoration-none text-reset d-flex flex-column align-items-center text-center" (click)="emitEventClicked(bien)">
    <div class="location text-center w-100">{{(bien.dist != null && bien.dist > 3) ? bien.dist+" KM - " : "" }}{{bien.ville | uppercase}}</div>
    <!-- <div (click)="manageFavorite(bien)">{{bien.favorite}}</div> -->
    <div class="details">
      <!-- SURFACE -->
      <ng-container *ngIf="bien.property.size_generique">
        <div>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.40446 3.85168H3.08008V6.17606" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M9.18199 11.9871H11.2158V9.95323" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M5.11391 11.9871H3.08008V9.95323" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M5.98555 9.37213L3.08008 11.9871" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M9.18199 3.85168H11.2158V5.88552" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.31035 6.46661L11.2158 3.85169" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="details-value">
          <span>
            {{bien.property.size_generique}}
          </span>
          <span *ngIf="bien.property.size_generique">m²</span>
        </div>
      </ng-container>

      <!-- ROOMS -->
      <ng-container *ngIf="bien.property.pieces && bien.typeid != 13">
        <div>
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.01309 6.46665V4.14227H1.20215V12.2776H12.2429V4.14227H9.62802" stroke="#131313"
              stroke-width="1.2203" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.68848 12.2776L4.68848 7.91937" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12.2429 8.2099H8.46582" stroke="#131313" stroke-width="1.2203" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="details-value">
          <span>
            {{bien.property.pieces}}
          </span>
          <span *ngIf="bien.property.pieces">p</span>
        </div>
      </ng-container>

      <!-- BEDROOMS -->
      <ng-container *ngIf="bien.property.room && bien.typeid != 13">
        <div>
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4686_42469)">
              <path
                d="M19.1635 18.388L17.8085 16.2649H4.63487L3.40301 18.3373C3.29432 18.5185 3.01172 18.446 3.01172 18.2286V10.9679C3.01172 10.7651 3.17838 10.5984 3.38127 10.5984H19.178C19.3809 10.5984 19.5475 10.7651 19.5475 10.9679V18.2793C19.5475 18.4895 19.2722 18.5692 19.1635 18.3953V18.388Z"
                stroke="#131313" stroke-width="1.2203" stroke-miterlimit="10" />
              <path
                d="M3.91016 10.5984V5.46811L4.06957 5.42463C8.80134 4.24351 13.7505 4.25075 18.475 5.44637L18.562 5.46811V10.5984"
                stroke="#131313" stroke-width="1.2203" stroke-miterlimit="10" />
              <path
                d="M12.5186 10.5984V9.69263C12.5186 8.48976 13.4968 8.10571 14.6997 8.10571C15.9025 8.10571 16.8808 8.48976 16.8808 9.69263V10.5984"
                stroke="#131313" stroke-width="1.2203" stroke-miterlimit="10" />
              <path
                d="M5.52539 10.5984V9.69263C5.52539 8.48976 6.49638 8.10571 7.69925 8.10571C8.90212 8.10571 9.88035 8.48976 9.88035 9.69263V10.5984"
                stroke="#131313" stroke-width="1.2203" stroke-miterlimit="10" />
            </g>
            <defs>
              <clipPath id="clip0_4686_42469">
                <rect width="18.4479" height="15.6896" fill="white" transform="translate(2.05957 3.6701)" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="details-value">
          <span>
            {{bien.property.room}}
          </span>
          <span *ngIf="bien.property.room">ch</span>
        </div>
      </ng-container>
    </div>
    <h5 class="price">{{bien.property.price_formatted}}&nbsp;€ {{bien.labelTaxe}}</h5>
    <div *ngIf="userConnected && showActifPub" class="actif-publication">
      <span *ngIf="bien.actif_tdm && [1, 3, 4].includes(bien.status.id)" title="Publié sur TDM"><i
          class="bi bi-check-circle premium"></i></span>
      <span *ngIf="!bien.actif_tdm || [2, 5, 6].includes(bien.status.id)" title="Non publié sur TDM"><i
          class="bi bi-circle"></i></span>
      <span *ngIf="bien.published_ubiflow" title="Publié sur sites partenaires"><i
          class="bi bi-speedometer premium"></i></span>
      <span *ngIf="!bien.published_ubiflow" title="Non publié sur sites partenaires"><i
          class="bi bi-speedometer"></i></span>
    </div>
    <div *ngIf="userConnected && showIconPartAcc" class="actif-publication">
      <span *ngIf="bien.mandatAccepted" title="Délégation acceptée"><i class="bi bi-check-circle premium"></i></span>
      <span *ngIf="!bien.mandatAccepted && bien.status.id != 1"
            title="Délégation non acceptée">
          <i class="bi bi-circle"></i>
      </span>
      <span *ngIf="!bien.mandatAccepted && bien.status.id == 1"
            title="Accepter la délégation">
          <i class="bi-pencil-fill"></i>
      </span>
    </div>
  </a>

</div>

<app-modal-alert-bien *ngIf="showAlert" [status]="statusConfirmation"
  [message]="messageConfirmation"></app-modal-alert-bien>
